export const DEFAULT_AUTO_BET_COUNT = 10;

export const AUTO_BET_LIMIT = {
  minBet: 1,
  maxBet: 50,
};
